import { Dialog, Box, Text } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { WizardProvider } from '@/components/modal-wizard-form/wizard-context'
import { usePaymentContext } from '@/components/ds-checkout-modal/payment-context'
import { DialogEventHandler } from '@/types'
import { breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'
import Content from './content'

type Props = {
  visible: boolean
  closeModal: DialogEventHandler
  selectedListing: { listingId?: string; address?: string }
}

const ModalDescription = ({ address = '' }) => {
  return (
    <Box style={{ textAlign: 'left' }} width="full">
      <Text size="medium" weight="regular">
        {address}
      </Text>
    </Box>
  )
}

const UseSyndicationCreditsModal = ({ visible, closeModal, selectedListing = {} }: Props) => {
  const { t } = useTranslation()
  const { setProduct, setCoupon } = usePaymentContext()
  const warningModal = {
    id: 'leaveUseCredit',
    title: t(
      'b.usage.dialog.are_you sure you want to exit?.text',
      'Are you sure you want to exit?'
    ),
    description: t(
      'b.usage.dialog.items_in_your_cart.text',
      'It looks like you have items in your cart. If you exit now, these items will be removed.'
    ),
    closeButtonLabel: t('b.usage.dialog.cancel.text', 'Cancel'),
    confirmButtonLabel: t('b.usage.dialog.yes_exit.text', 'Yes, exit')
  }
  const handleClose = () => {
    setCoupon('')
    setProduct({})
    closeModal()
  }
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  return (
    <Dialog
      id="UseSyndicationCreditsModal"
      title={t('l.usage.dialog.multi_platform_advertising.title', 'Multi-platform Advertising')}
      description={<ModalDescription address={selectedListing?.address} />}
      open={visible}
      warningModal={warningModal}
      onClose={handleClose}
      width={isMobile ? undefined : 'content'}
    >
      <WizardProvider>
        <Content closeModal={closeModal} selectedListingId={selectedListing?.listingId} />
      </WizardProvider>
    </Dialog>
  )
}

export default UseSyndicationCreditsModal
